/*!
 * hScroll.js
 * Author: Mr. Huang
 *
 */
;
(function() {
	function hScroll(options) {
		let self = this;
		self = Object.assign(self, {
			nav1: '',
			nav2: '',
			nav3:0,
			check: '',
		}, options);
		self.init();
	}
	hScroll.prototype = {
		init: function() {
			let self = this,
				arr = [],
				kdiv = $(self.nav2);
			for (let i = 0; i < kdiv.length; i++) {
				arr.push($(kdiv[i]).offset().top);
			}
			self.sctopFun(arr);
			$(self.nav1).off("click");
			$(window).scroll(function(e) {
				self.sctopFun(arr);
			});
			$(self.nav1).click(function(e) {
				let htmlHeight=0,bodyHeight=0,cha=0;
				if($(this).index()==arr.length-1){
					htmlHeight= window.innerHeight || document.documentElement.clientHeight;
					bodyHeight=document.body.clientHeight;
					if((bodyHeight-arr[$(this).index()])<(htmlHeight-300)){
						cha=htmlHeight-(bodyHeight-arr[$(this).index()])-self.nav3-10;
					}
				}
				
				console.log(arr,arr[$(this).index()]-self.nav3-10,arr[$(this).index()]-self.nav3-10-cha);
				$('body,html').animate({
					scrollTop: arr[$(this).index()]-self.nav3-10-cha
				});
			});
		},
		sctopFun: function(arr) {
			let self = this;
			let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window
				.pageYOffset;
			let keys = 0,
				flag = true;
			for (let i = 0; i < arr.length; i++) {
				keys++;
				if (flag) {
					if (scrollTop >= arr[arr.length - keys] - 300) {
						$(self.nav1).eq(arr.length - keys).addClass(self.checkClass).siblings().removeClass(
							self.checkClass);
						flag = false;
					} else {
						flag = true;
					}
				}
			}
		},
	}
	window.hScroll = hScroll;
}());
